<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/Machine/ListMachine'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>

        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="form-group">
                  <label>คำค้นหา:</label>
                  <input
                    id="lmReqSearch"
                    name="lmReqSearch"
                    v-model="lmReqSearch"
                    type="text"
                    class="form-control"
                    placeholder="ค้นหาจาก เลขที่ PO, เลขที่ Invoice, ค่าเช่า, BARCODE, รหัสทรัพย์สิน(เบียร์สด) เช่น 1234,BARCODE123"
                  />
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group ">
                  <label class="label">วันที่ติดตั้ง(เริ่มต้น):</label>
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="lmDateInstallStart"
                      name="lmDateInstallStart"
                      ref="lmDateInstallStart"
                      readonly="readonly"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label">วันที่ติดตั้ง(สิ้นสุด):</label>
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="lmDateInstallEnd"
                      name="lmDateInstallEnd"
                      ref="lmDateInstallEnd"
                      readonly="readonly"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group ">
                  <label class="label">วันที่วางบิล(เริ่มต้น):</label>
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="lmDateOfBillingDate_Start"
                      name="lmDateOfBillingDate_Start"
                      ref="lmDateOfBillingDate_Start"
                      readonly="readonly"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label">วันที่วางบิล(สิ้นสุด):</label>
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="lmDateOfBillingDate_End"
                      name="lmDateOfBillingDate_End"
                      ref="lmDateOfBillingDate_End"
                      readonly="readonly"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group ">
                  <!-- <label class="label">วันหมดสัญญาเช่า(เริ่มต้น):</label> -->
                  <label class="label">วันที่หมดสัญญาเช่า(เริ่มต้น):</label>
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="lmContractExpireDate_Start"
                      name="lmContractExpireDate_Start"
                      ref="lmContractExpireDate_Start"
                      readonly="readonly"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <!-- <label class="label">วันหมดสัญญาเช่า(สิ้นสุด):</label> -->
                  <label class="label">วันที่หมดสัญญาเช่า(สิ้นสุด):</label>
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="lmContractExpireDate_End"
                      name="lmContractExpireDate_End"
                      ref="lmContractExpireDate_End"
                      readonly="readonly"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>Supplier:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'lmSupplierId'"
                    :name="'lmSupplierId'"
                    :select2-options="lmSupplierIdOptions"
                    multiple
                    v-model="lmSupplierId"
                  ></select2> -->
                  <treeselect
                    v-model="lmSupplierId"
                    :multiple="true"
                    :load-options="LoadlmSupplierIdOptions"
                    :async="true"
                    v-on:select="ClearAfterselect"
                    placeholder="กรุณาเลือก"
                    :cacheOptions="false"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>Phase:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'lmPhase'"
                    :name="'lmPhase'"
                    :select2-options="lmPhaseOptions"
                    multiple
                    v-model="lmPhase"
                  ></select2> -->
                  <treeselect
                    v-model="lmPhase"
                    :multiple="true"
                    :options="lmPhaseOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>Lot:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'lmLot'"
                    :name="'lmLot'"
                    :select2-options="lmLotOptions"
                    multiple
                    v-model="lmLot"
                  ></select2> -->
                  <treeselect
                    v-model="lmLot"
                    :multiple="true"
                    :options="lmLotOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ตัวแทนจำหน่าย:</label>
                  <!-- <label>Agent:</label> -->
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'lmAgentCode'"
                    :name="'lmAgentCode'"
                    :select2-options="lmAgentCodeOptions"
                    multiple
                    v-model="lmAgentCode"
                  ></select2> -->
                  <treeselect
                    v-model="lmAgentCode"
                    :multiple="true"
                    :options="lmAgentCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ชื่อร้านค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'lmShop'"
                    :name="'lmShop'"
                    :select2-options="lmShopOptions"
                    multiple
                    v-model="lmShop"
                  ></select2> -->
                  <treeselect
                    v-model="lmShop"
                    :multiple="true"
                    :options="lmShopOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ประเภทสินค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'lmProductTypeCode'"
                    :name="'lmProductTypeCode'"
                    :select2-options="lmProductTypeCodeptions"
                    multiple
                    v-model="lmProductTypeCode"
                  ></select2> -->
                  <treeselect
                    v-model="lmProductTypeCode"
                    :multiple="true"
                    :options="lmProductTypeCodeptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ชื่อสินค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'lmProductCode'"
                    :name="'lmProductCode'"
                    :select2-options="lmProductCodeOptions"
                    multiple
                    v-model="lmProductCode"
                  ></select2> -->
                  <treeselect
                    v-model="lmProductCode"
                    :multiple="true"
                    :options="lmProductCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>แบรนด์เครื่องเบียร์สด:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'lmMachineProductBrandId'"
                    :name="'lmMachineProductBrandId'"
                    :select2-options="lmMachineProductBrandIdOptions"
                    multiple
                    v-model="lmMachineProductBrandId"
                  ></select2> -->
                  <treeselect
                    v-model="lmMachineProductBrandId"
                    :multiple="true"
                    :options="lmMachineProductBrandIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>จังหวัด:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'lmShopProvinceId'"
                    :name="'lmShopProvinceId'"
                    :select2-options="lmShopProvinceIdOptions"
                    multiple
                    v-model="lmShopProvinceId"
                  ></select2> -->
                  <treeselect
                    v-model="lmShopProvinceId"
                    :multiple="true"
                    :options="lmShopProvinceIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">ค้นหา</button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <button
                  class="btn btn-outline-primary"
                  @click="exportListMachine"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Table -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable display nowrap"
                id="MachineDetailTable"
                style="width:100%"
              >
                <thead>
                  <tr>
                    <th class="all text-center">Supplier</th>
                    <th class="all text-center">Phase</th>
                    <th class="all text-center">Lot</th>
                    <th class="all text-center">งวดที่ชำระล่าสุด</th>
                    <th class="all text-center">วัน (ที่ติดตั้ง)</th>
                    <th class="all text-center">เดือน (ที่ติดตั้ง)</th>
                    <th class="all text-center">ปี (ที่ติดตั้ง)</th>
                    <th class="all text-center">วันที่วางบิล</th>
                    <!-- <th class="all text-center">วันหมดสัญญาเช่า</th> -->
                    <th class="all text-center">วัน (ที่หมดสัญญาเช่า)</th>
                    <th class="all text-center">เดือน (ที่หมดสัญญาเช่า)</th>
                    <th class="all text-center">ปี (ที่หมดสัญญาเช่า)</th>
                    <th class="all text-center">เลขที่ PO</th>
                    <th class="all text-center">เลขที่ Invoice</th>
                    <th class="all text-center">ค่าเช่าต่องวด</th>
                    <th class="all text-center">BARCODE</th>
                    <th class="all text-center">รหัสทรัพย์สิน(เบียร์สด)</th>
                    <th class="all text-center">ประเภทสินค้า</th>
                    <th class="all text-center">ชื่อสินค้า</th>
                    <th class="all text-center">แบรนด์</th>
                    <th class="all text-center">จังหวัด</th>
                    <th class="all text-center">เอเย่นต์</th>
                    <th class="all text-center">ชื่อร้านค้า</th>
                    <th class="all text-center">ชื่อร้านค้า 2</th>
                  </tr>
                </thead>

                <!-- <tfoot v-show="isShowFooter">
                    <tr>
                        <th class="text-right" colspan="6">จำนวนรวม</th>
                        <th class="text-center">{{TotalAmount}}</th> 
                        <th class="text-center" colspan="5"></th> 
                    </tr>
                </tfoot> -->
              </table>
            </div>
          </div>
          <!--end: Table -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import DatatableWarning from "../../Shared/DatatableWarning";


require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;

    return {
      lmReqSearch: null,
      lmDateInstallStart: null,
      lmDateInstallEnd: null,
      lmDateOfBillingDate_Start: null,
      lmDateOfBillingDate_End: null,
      lmContractExpireDate_Start: null,
      lmContractExpireDate_End: null,
      lmAgentCode: [],
      lmPhase: [],
      lmLot: [],
      lmShop: [],
      lmProductTypeCode: [],
      lmMachineProductBrandId: [],
      lmProductCode: [],
      lmSupplierId: [],
      lmShopProvinceId: [],
      lmAgentCodeOptions: [],
      // lmAgentCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกAgent",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2Agent",
      //     type: "post",
      //     delay: 300,
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //         province_id: [],
      //         department: [],
      //         AgentCodes: [],
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      lmShopOptions: [],
      // lmShopOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกร้านค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Shop/ShopOption",
      //     type: "post",
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      lmProductTypeCodeptions: [],
      // lmProductTypeCodeptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกประเภทสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     delay: 300,
      //     url: "/Api/ProductType/Select2ProductType",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      lmProductCodeOptions: [],
      // lmProductCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Product/Select2Product",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      lmShopProvinceIdOptions: [],
      // lmShopProvinceIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกจังหวัด",
      //   ajax: {
      //     url: "/Api/MasterLocation/Select2SearchProvince",
      //     type: "post",
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      lmSupplierIdOptions: [],
      // lmSupplierIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกSupplier",
      //   allowClear: true,
      //   ajax: {
      //     delay: 300,
      //     url: "/Api/Vendors/Select2Vendor",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      lmPhaseOptions: [],
      // lmPhaseOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือก Phase",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/MasterPhase/Select2Phase",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      lmLotOptions: [],
      // lmLotOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือก Lot",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/MasterPhase/Select2Lot",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      lmMachineProductBrandIdOptions: [],
      // lmMachineProductBrandIdOptions: {
      //   placeholder: "กรุณาเลือก แบรนด์เครื่องเบียร์สด",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductBrand/Select2BrandMachine",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //         ProductType: [3],
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      //   templateResult: function(data) {
      //     return data.text;
      //   },
      //   language: {
      //     noResults: function() {
      //       return "ไม่พบข้อมูลร้านค้า";
      //     },
      //   },
      // },
    };
  },
  computed: {},
  methods: {
    formReset: function(e) {
      let self = this;
      self.lmReqSearch = null;
      self.lmDateInstallStart = null;
      self.lmDateInstallEnd = null;
      self.lmDateOfBillingDate_Start = null;
      self.lmDateOfBillingDate_End = null;
      self.lmContractExpireDate_Start = null;
      self.lmContractExpireDate_End = null;
      self.lmAgentCode = [];
      self.lmPhase = [];
      self.lmLot = [];
      self.lmShop = [];
      self.lmProductTypeCode = [];
      self.lmMachineProductBrandId = [];
      self.lmProductCode = [];
      self.lmSupplierId = [];
      self.lmShopProvinceId = [];

      $("#lmDateInstallStart")
        .val(null)
        .trigger("change");
      $("#lmDateInstallEnd")
        .val(null)
        .trigger("change");
      $("#lmDateOfBillingDate_Start")
        .val(null)
        .trigger("change");
      $("#lmDateOfBillingDate_End")
        .val(null)
        .trigger("change");
      $("#lmContractExpireDate_Start")
        .val(null)
        .trigger("change");
      $("#lmContractExpireDate_End")
        .val(null)
        .trigger("change");

      $("#lmAgentCode")
        .val("")
        .trigger("change");

      $("#lmPhase")
        .val("")
        .trigger("change");

      $("#lmLot")
        .val("")
        .trigger("change");

      $("#lmShop")
        .val("")
        .trigger("change");

      $("#lmProductTypeCode")
        .val("")
        .trigger("change");

      $("#lmMachineProductBrandId")
        .val("")
        .trigger("change");

      $("#lmProductCode")
        .val("")
        .trigger("change");

      $("#lmSupplierId")
        .val("")
        .trigger("change");

      $("#lmShopProvinceId")
        .val("")
        .trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function(e) {
      let self = this;

      e.preventDefault();
      var table = $("#MachineDetailTable").DataTable();
      table.draw();
    },
    exportListMachine: function(e) {
      e.preventDefault();
      let self = this;

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/MachineTransaction/ExportListMachine",
        responseType: "arraybuffer",
        data: {
          SearchKeyword: self.lmReqSearch,
          DateInstallStart:
            self.lmDateInstallStart != null
              ? self.lmDateInstallStart.format("DD/MM/YYYY")
              : self.lmDateInstallStart,
          DateInstallEnd:
            self.lmDateInstallEnd != null
              ? self.lmDateInstallEnd.format("DD/MM/YYYY")
              : self.lmDateInstallEnd,
          DateOfBillingDate_Start:
            self.lmDateOfBillingDate_Start != null
              ? self.lmDateOfBillingDate_Start.format("DD/MM/YYYY")
              : self.lmDateOfBillingDate_Start,
          DateOfBillingDate_End:
            self.lmDateOfBillingDate_End != null
              ? self.lmDateOfBillingDate_End.format("DD/MM/YYYY")
              : self.lmDateOfBillingDate_End,
          ContractExpireDate_Start:
            self.lmContractExpireDate_Start != null
              ? self.lmContractExpireDate_Start.format("DD/MM/YYYY")
              : self.lmContractExpireDate_Start,
          ContractExpireDate_End:
            self.lmContractExpireDate_End != null
              ? self.lmContractExpireDate_End.format("DD/MM/YYYY")
              : self.lmContractExpireDate_End,
          AgentCode: self.lmAgentCode,
          Phase: self.lmPhase,
          Lot: self.lmLot,
          ShopCode: self.lmShop,
          ProductTypeCode: self.lmProductTypeCode,
          MachineProductBrandId: self.lmMachineProductBrandId,
          ProductCode: self.lmProductCode,
          SupplierId: self.lmSupplierId,
          ShopProvinceId: self.lmShopProvinceId,
        },
      })
        .then(function(response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];

            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          //self.formReset();
          KTApp.unblockPage();
        });
    },
    LoadlmAgentCodeOptions: function(e) {
      var self = this;
      axios
        .post("/Api/Report/Select2Agent", {
          province_id: [],
          department: [],
          AgentCodes: [],
          page: 1,
          all: true,
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.lmAgentCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadlmProductTypeCodeptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductType/Select2ProductType", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.lmProductTypeCodeptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadlmProductCodeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Product/Select2Product", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.lmProductCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadlmShopProvinceIdOptions: function(e) {
      var self = this;
      axios
        .post("/Api/MasterLocation/Select2SearchProvince", {
          page: 1,
          all: true,
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.lmShopProvinceIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadlmSupplierIdOptions({ action, searchQuery, callback }) {
      var self = this;
      self.lmSupplierIdOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .get("/Api/Vendors/Select2Vendor", {
            params: {
              page: 1,
              all: true,
              search: searchQuery,
            },
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.lmSupplierIdOptions = [];
              data.forEach((element) => {
                self.lmSupplierIdOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }

            callback(null, self.lmSupplierIdOptions);
          })
          .catch(function(error) {});
      }
    },
    LoadlmPhaseOptions: function(e) {
      var self = this;
      axios
        .get("/Api/MasterPhase/Select2Phase", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.lmPhaseOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadlmLotOptions: function(e) {
      var self = this;
      axios
        .post("/Api/MasterPhase/Select2Lot", {
          page: 1,
          Phases: self.lmPhase,
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.lmLotOptions = [];
            data.forEach((element) => {
              self.lmLotOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadlmMachineProductBrandIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductBrand/Select2BrandMachine", {
          params: {
            page: 1,
            ProductType: [3],
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.lmMachineProductBrandIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadlmShopOptions: function(e) {
      var self = this;
      axios
        .post("/Api/Shop/ShopOption", {})
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.lmShopOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    ClearAfterselect: function(){
      $(`[class="vue-treeselect__input"]`).val("");
    }
  },
  async mounted() {
    let self = this;

    self.LoadlmAgentCodeOptions();
    self.LoadlmProductTypeCodeptions();
    self.LoadlmProductCodeOptions();
    self.LoadlmShopProvinceIdOptions();
    // self.LoadlmSupplierIdOptions();
    self.LoadlmPhaseOptions();
    self.LoadlmLotOptions();
    self.LoadlmMachineProductBrandIdOptions();
    self.LoadlmShopOptions();

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

    $(self.$refs.lmDateInstallStart).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reBcTransferJobCommitDateStart = moment().set("date",1);
    $(self.$refs.lmDateInstallStart)
      .datepicker(
        "update",
        !!self.lmDateInstallStart
          ? self.lmDateInstallStart.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        self.lmDateInstallStart = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.lmDateInstallEnd).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reBcTransferJobCommitDateStart = moment().set("date",1);
    $(self.$refs.lmDateInstallEnd)
      .datepicker(
        "update",
        !!self.lmDateInstallEnd
          ? self.lmDateInstallEnd.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        self.lmDateInstallEnd = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.lmDateOfBillingDate_Start).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reBcTransferJobCommitDateStart = moment().set("date",1);
    $(self.$refs.lmDateOfBillingDate_Start)
      .datepicker(
        "update",
        !!self.lmDateOfBillingDate_Start
          ? self.lmDateOfBillingDate_Start.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        self.lmDateOfBillingDate_Start =
          e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.lmDateOfBillingDate_End).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reBcTransferJobCommitDateStart = moment().set("date",1);
    $(self.$refs.lmDateOfBillingDate_End)
      .datepicker(
        "update",
        !!self.lmDateOfBillingDate_End
          ? self.lmDateOfBillingDate_End.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        self.lmDateOfBillingDate_End =
          e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.lmContractExpireDate_Start).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reBcTransferJobCommitDateStart = moment().set("date",1);
    $(self.$refs.lmContractExpireDate_Start)
      .datepicker(
        "update",
        !!self.lmContractExpireDate_Start
          ? self.lmContractExpireDate_Start.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        self.lmContractExpireDate_Start =
          e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.lmContractExpireDate_End).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reBcTransferJobCommitDateStart = moment().set("date",1);
    $(self.$refs.lmContractExpireDate_End)
      .datepicker(
        "update",
        !!self.lmContractExpireDate_End
          ? self.lmContractExpireDate_End.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        self.lmContractExpireDate_End =
          e.dates.length != 0 ? moment(e.date) : null;
      });

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#MachineDetailTable");
    //begin first table
    table
      .DataTable({
        autoWidth: true,
        scrollY: "100%",
        scrollX: true,
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/MachineTransaction/SearchMachineTransaction",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            let jsonSearch = {
              SearchKeyword: self.lmReqSearch,
              DateInstallStart:
                self.lmDateInstallStart != null
                  ? self.lmDateInstallStart.format("DD/MM/YYYY")
                  : self.lmDateInstallStart,
              DateInstallEnd:
                self.lmDateInstallEnd != null
                  ? self.lmDateInstallEnd.format("DD/MM/YYYY")
                  : self.lmDateInstallEnd,
              DateOfBillingDate_Start:
                self.lmDateOfBillingDate_Start != null
                  ? self.lmDateOfBillingDate_Start.format("DD/MM/YYYY")
                  : self.lmDateOfBillingDate_Start,
              DateOfBillingDate_End:
                self.lmDateOfBillingDate_End != null
                  ? self.lmDateOfBillingDate_End.format("DD/MM/YYYY")
                  : self.lmDateOfBillingDate_End,
              ContractExpireDate_Start:
                self.lmContractExpireDate_Start != null
                  ? self.lmContractExpireDate_Start.format("DD/MM/YYYY")
                  : self.lmContractExpireDate_Start,
              ContractExpireDate_End:
                self.lmContractExpireDate_End != null
                  ? self.lmContractExpireDate_End.format("DD/MM/YYYY")
                  : self.lmContractExpireDate_End,
              AgentCode: self.lmAgentCode,
              Phase: self.lmPhase,
              Lot: self.lmLot,
              ShopCode: self.lmShop,
              ProductTypeCode: self.lmProductTypeCode,
              MachineProductBrandId: self.lmMachineProductBrandId,
              ProductCode: self.lmProductCode,
              SupplierId: self.lmSupplierId,
              ShopProvinceId: self.lmShopProvinceId,
            };
            return JSON.stringify($.extend(d, jsonSearch));
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [100, 500],

        pageLength: 100,

        language: {
          lengthMenu: "Display _MENU_",
        },
        // Order settings
        order: [[1, "desc"]],
        columns: [
          { data: "supplierName", className: "text-center" },
          { data: "phase", className: "text-center" },
          { data: "lot", className: "text-center" },
          { data: "installmentLatest", className: "text-center" },
          { data: "dateInstallDay", className: "text-center" },
          { data: "dateInstallMonth", className: "text-center" },
          { data: "dateInstallYear", className: "text-center" },
          { data: "dateOfBillingString", className: "text-center" },
          // { data: "contractExpireDateString", className: "text-center" },
          { data: "contractExpireDay", className: "text-center" },
          { data: "contractExpireMonth", className: "text-center" },
          { data: "contractExpireYear", className: "text-center" },
          { data: "po", className: "text-center" },
          { data: "invoiceNo", className: "text-center" },
          {
            data: "price",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data != null) {
                return data
                  .toFixed(0)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return "";
              }
            },
          },
          { data: "barcodeOldNO", className: "text-center" },
          { data: "departmentMaterialCode", className: "text-center" },
          { data: "machineProductTypeName", className: "text-center" },
          { data: "machineProductName", className: "text-center" },
          { data: "machineProductBrandName", className: "text-center" },
          { data: "agentProvinceName", className: "text-center" },
          { data: "agentName", className: "text-center" },
          { data: "shopName", className: "text-center" },
          { data: "shopName2", className: "text-center" },
        ],
        drawCallback: function(settings) {
          // self.reAaIsInitial = false;
          // self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");
          // var allPage = table.DataTable().page.info().pages;
          // var currentPage = table.DataTable().page.info().page +1;
          // self.isShowFooter = false;
          // self.TotalAmount = 0;
          // if(allPage == currentPage){
          //   self.isShowFooter = true;
          //   self.TotalAmount = settings.json.data[0].totalAmount;
          // }
        },
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        // var t = table.DataTable();
        // var page = t.page.info().start + 1;
        // t.column(0, {}).nodes().each( function (cell, i) {
        //     cell.innerHTML = i+page;
        // } );
      });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
  watch: {
    lmPhase: function() {
      //console.log(this.remdPhase);
      this.LoadlmLotOptions();
    },
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Machine/ListMachine.vue